export default __webpack_public_path__ + "static/media/Mark-3-3D-Model-00.008b0b93.jpg";